<!-- App.svelte -->
<script>
  import { Router, Link, Route } from "svelte-routing";
  import Api from "./api.js";
  import Header from "./ui/header.svelte";
  import { fade } from 'svelte/transition';
  import Home from "./route/home.svelte";
  import ArticleList from "./route/articleList.svelte";
  import ArticleView from "./route/articleView.svelte";
//  import {payModal} from "./ui/modal/modal.js";
//  payModal();
  export let url = "";

  var api = new Api();
  if (typeof global === 'undefined') {
    window.api = api;
  }
  else{
      if (ssrContext.url) url = ssrContext.url;
  }
  const routeContext = {
    api: api
  }
  
</script>

<div class="app">
  <Header {...routeContext}/>
  <Router url="{url}">
    
      <Route path="/">
        <div id="app_body" in:fade="{{duration:200}}"><Home {...routeContext} /></div>
      </Route>
      <Route path="/articles">
        <div id="app_body" in:fade="{{duration:200}}"> <ArticleList {...routeContext}/></div>
      </Route>
      <Route path="/topic/:url" let:params>
        <div id="app_body" in:fade="{{duration:200}}"><ArticleView {...routeContext} url={params.url}/></div>
      </Route>
    
  </Router>
</div>

<style type="text/css">
  .app{
    display: flex;
  }
  @media(max-width: 1015px){
    .app{
      flex-direction: column;
    }
  }
</style>